import type { UserRole } from "@/api/custom_types";
import type { FileRouteTypes } from "@/routeTree.gen";

const routeRoleMap: Partial<Record<FileRouteTypes["to"], UserRole[] | "ALL">> =
	{
		"/": "ALL",
		"/login": "ALL",
		"/signup": "ALL",
		"/forgetPassword": "ALL",
		// FC_USER routes
		"/dashboard": ["FC_USER"],
		"/sell-coin": ["FC_USER"],
		"/history": ["FC_USER"],
		"/wallet": ["FC_USER"],
		"/profile": ["FC_USER"],
		"/profile/transfer-multiplier-guide": ["FC_USER"],
		// PO routes
		"/payment-history": ["ADMIN", "PO"],
		// Admin routes (flat navigation - tabs are inside pages)
		"/admin/dashboard": ["ADMIN"],
		"/admin/users": ["ADMIN"],
		"/admin/users/$userId": ["ADMIN"],
		"/admin/player-auction": ["ADMIN"],
		"/admin/player-auction/senders/$senderId": ["ADMIN"],
		"/admin/comfort-trade": ["ADMIN"],
		"/admin/comfort-trade/senders/$senderEmail": ["ADMIN"],
		"/admin/fast-sell": ["ADMIN"],
		"/admin/banners": ["ADMIN"],
		"/admin/financial-report": ["ADMIN"],
		"/admin/profile": ["ADMIN"],
		"/admin/settings": ["ADMIN"],
	};

export function canAccessRoute(
	userRole: UserRole | undefined,
	routePath: FileRouteTypes["to"],
) {
	const allowedRoles = routeRoleMap[routePath];
	if (!userRole) return false;
	if (!allowedRoles || allowedRoles === "ALL") return true;
	return allowedRoles.includes(userRole);
}
